import React from 'react';

import autoBind from 'react-autobind';
import Switch, { Case } from 'react-switch-case';

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"

import PinEditor from "composer/views/stage/PlaybackElement/PinEditor.jsx"

import {
  Grid,
  TextField,
  FormControl,
  Select,
  MenuItem,
} from '@material-ui/core';

const playbackKind = 5; // Treasure

class TreasureForm extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    var defaultPayloadData = { kind: 0 };

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      pos_x: 0,
      pos_y: 0,
      countDownLimit: 3600,
      content: "",
      triggerMode: 0,
      payloadData: defaultPayloadData,

      visibility: 0,
    };
    autoBind(this);

    if (this.props.playbackData != null) {
      this.state.pos_x = parseFloat(this.props.playbackData['pos_x']);
      this.state.pos_y = parseFloat(this.props.playbackData['pos_y']);
      this.state.countDownLimit = parseFloat(this.props.playbackData['countdown_limit']);
      this.state.content = this.props.playbackData['content'];
      this.state.triggerMode = this.props.playbackData['trigger_mode'];
      this.state.payloadData = (this.props.playbackData['payload'] != ""? JSON.parse(this.props.playbackData['payload']) : defaultPayloadData);
    }
    this.state.visibility = this.props.parent.countdownLimitToVisibility(this.state.countDownLimit);
  }

  onContentChanged(e) {
    this.setState({
      content: e.target.value,
    });
    this.state.content = e.target.value;
  }

  visibilityChanged(e) {
    let countDownLimit = this.props.parent.visibilityToCountdownLimit(e.target.value);
    this.setState({
      visibility: e.target.value,
      countDownLimit: countDownLimit,
    });
    this.state.visibility = e.target.value;
    this.state.countDownLimit = countDownLimit;
  }

  validateInput() {
    let result = true;
    if (this.state.content.trim() == "") {
      this.props.root.addNotification("Description cannot be blank");
      result = false;
    }
    return result;
  }

  updatePlayback(new_id) {
    let requestObj = {
      playback_id: new_id,
      kind: playbackKind,
      trigger_time: (this.props.playbackData? this.props.playbackData['trigger_time'] : this.props.root.refs.stageViewerPage.refs.stageDetailView.refs.stageMediaView.state.playbackTime),
      should_pause_video: Config.GET_PLAYBACK_CONFIG(playbackKind)['shouldPauseVideo'],
      pos_x: this.state.pos_x,
      pos_y: this.state.pos_y,
      countdown_limit: this.state.countDownLimit,
      content: this.state.content.trim(),
      payload: JSON.stringify(this.state.payloadData),
    };
    this.props.root.refs.API.request("update_playback", requestObj, this.props.parent.updatePlaybackOK, this.props.parent.updatePlaybackFailed);
  }

  onPinPositionUpdate(pos) {
    this.setState({
      pos_x: pos.x,
      pos_y: pos.y,
    });
    this.state.pos_x = pos.x;
    this.state.pos_y = pos.y;
  }

  render() {
    return (
      <div>
        <Switch condition={this.props.parent.state.activeView}>
          <Case value={0}>
            <PinEditor parent={this} root={this.props.root} ref="pinEditor"
              db_x={this.state.pos_x} db_y={this.state.pos_y}
            />
          </Case>
          <Case value={1}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={2}>
                {Localization.strings.DESCRIPTION}
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  value={this.state.content}
                  onChange={this.onContentChanged}
                />
              </Grid>
              <Grid item sm={4}/>
              <Grid item xs={12} sm={2}>
                {Localization.strings.VISIBILITY}
              </Grid>
              <Grid item xs={12} sm={10}>
                <FormControl>
                  <Select
                    value={this.state.visibility}
                    onChange={this.visibilityChanged}
                  >
                    <MenuItem value={0}>{Localization.strings.ALWAYS}</MenuItem>
                    <MenuItem value={1}>{"120 " + Localization.strings.SECONDS}</MenuItem>
                    <MenuItem value={2}>{"60 " + Localization.strings.SECONDS}</MenuItem>
                    <MenuItem value={3}>{"45 " + Localization.strings.SECONDS}</MenuItem>
                    <MenuItem value={4}>{"30 " + Localization.strings.SECONDS}</MenuItem>
                    <MenuItem value={5}>{"15 " + Localization.strings.SECONDS}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Case>
        </Switch>
      </div>
    )
  }
}

export default TreasureForm;
